import { Component, OnInit } from '@angular/core';
import { BankTransactionsService } from '../../../services/bank-transactions.service';
import { BankTransaction } from '../../../models/BankTransaction';

@Component({
  selector: 'app-bank-transactions',
  templateUrl: './bank-transactions.component.html',
  styleUrls: ['./bank-transactions.component.css']
})
export class BankTransactionsComponent implements OnInit {
  tableTitle = 'Transações Bancárias';
  showSearch = true;
  searchPlaceholder = 'Pesquisar transações...';
  clickable = true;

  columns = [
    { titulo: 'Data', label: 'transactionDate', pipe: 'date' },
    { titulo: 'Descrição', label: 'description' },
    { titulo: 'Valor', label: 'amount', pipe: 'currency' },
    { titulo: 'Tipo', label: 'type', badge: true }
  ];

  actions = [
    { label: 'Visualizar', icon: 'fas fa-eye', action: 'view', class: 'btn-view' },
    { label: 'Editar', icon: 'fas fa-pen-to-square', action: 'edit', class: 'btn-edit' },
    { label: 'Excluir', icon: 'fas fa-trash-can', action: 'delete', class: 'btn-delete' }
  ];

  transactions: BankTransaction[] = [];
  loading = false;
  error: string | null = null;

  startDate: string = '';
  endDate: string = '';
  showUnlinked: boolean = false;

  constructor(private bankTransactionsService: BankTransactionsService) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  onSearch(term: string): void {}

  onDateRangeChange(): void {
    this.applyFilters();
  }

  onToggleUnlinked(): void {
    this.showUnlinked = !this.showUnlinked;
    this.applyFilters();
  }

  applyFilters(): void {
    this.loading = true;
    this.error = null;

    if (this.showUnlinked) {
      this.bankTransactionsService.getUnlinked().subscribe({
        next: (res) => {
          this.transactions = res.items || [];
          this.loading = false;
        },
        error: (err) => {
          this.error = err?.message || 'Erro ao carregar transações';
          this.loading = false;
        }
      });
      return;
    }

    if (this.startDate && this.endDate) {
      this.bankTransactionsService.getByDateRange(this.startDate, this.endDate).subscribe({
        next: (res) => {
          this.transactions = res.items || [];
          this.loading = false;
        },
        error: (err) => {
          this.error = err?.message || 'Erro ao carregar transações';
          this.loading = false;
        }
      });
      return;
    }

    // Se não tiver filtros, busca todas
    this.bankTransactionsService.getAll().subscribe({
      next: (res) => {
        this.transactions = res || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message || 'Erro ao carregar transações';
        this.loading = false;
        this.transactions = [];
      }
    });
  }

  onActionClick(actionData: {action: string, item: any}): void {
    const { action } = actionData;
    if (action === 'view') { return; }
    if (action === 'edit') { this.openEdit(actionData.item); return; }
    if (action === 'delete') { this.deleteItem(actionData.item?.id); return; }
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  showForm: boolean = false;
  editMode: boolean = false;
  currentId: number | null = null;
  formData: { transactionDate: string; description: string; amount: number; type: string; bankStatementId: number } = { 
    transactionDate: '', description: '', amount: 0, type: 'Debit', bankStatementId: 0 
  };

  openNew(): void {
    this.editMode = false;
    this.currentId = null;
    this.formData = { 
      transactionDate: new Date().toISOString().split('T')[0], 
      description: '', 
      amount: 0, 
      type: 'Debit', 
      bankStatementId: 0 
    };
    this.showForm = true;
  }

  openEdit(item: any): void {
    this.editMode = true;
    this.currentId = item?.id ?? null;
    this.formData = {
      transactionDate: item?.transactionDate ? new Date(item.transactionDate).toISOString().split('T')[0] : '',
      description: item?.description ?? '',
      amount: item?.amount ?? 0,
      type: item?.type ?? 'Debit',
      bankStatementId: item?.bankStatementId ?? 0
    };
    this.showForm = true;
  }

  cancelForm(): void {
    this.showForm = false;
  }

  submitForm(): void {
    const payload: any = {
      transactionDate: this.formData.transactionDate,
      description: this.formData.description,
      amount: Number(this.formData.amount),
      type: this.formData.type,
      bankStatementId: this.formData.bankStatementId
    };
    this.loading = true;
    this.error = null;
    const done = () => { this.loading = false; this.showForm = false; this.applyFilters(); };
    const fail = (err: any) => { this.error = err?.message || 'Erro ao salvar'; this.loading = false; };
    if (this.editMode && this.currentId) {
      payload.id = this.currentId;
      this.bankTransactionsService.update(this.currentId, payload).subscribe({ next: done, error: fail });
    } else {
      this.bankTransactionsService.create(payload).subscribe({ next: done, error: fail });
    }
  }

  deleteItem(id: number): void {
    if (!id) return;
    this.loading = true;
    this.error = null;
    this.bankTransactionsService.delete(id).subscribe({
      next: () => { this.loading = false; this.applyFilters(); },
      error: (err) => { this.error = err?.message || 'Erro ao excluir'; this.loading = false; }
    });
  }
}
